var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 45,
    viewBox: "0 0 40 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.4638 43.945C25.6024 43.9563 25.6024 44.1301 25.4638 44.1415C24.1009 44.253 21.5833 44.4194 18.7028 44.4194C15.8224 44.4194 13.3047 44.253 11.9419 44.1415C11.8032 44.1301 11.8032 43.9563 11.9419 43.945C13.3047 43.8335 15.8224 43.667 18.7028 43.667C21.5833 43.667 24.1009 43.8335 25.4638 43.945Z",
    fill: "#E6E6E6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6376 0.15332C12.4843 0.185965 13.3224 0.485439 14.0161 1.05215L8.3647 6.7217C7.7998 6.02583 7.50129 5.18499 7.46875 4.33563C8.00818 3.59779 8.65877 2.83582 9.40071 2.09149C10.1426 1.34717 10.9024 0.694484 11.6376 0.15332Z",
    fill: "url(#paint0_linear_7398_12448)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2493 0.872752L11.7071 0.333008C10.2921 1.44068 9.11016 2.57998 8.07617 3.89041L8.3953 4.03944C9.73852 2.77118 11.3511 1.71177 13.2493 0.872955V0.872752Z",
    fill: "url(#paint1_linear_7398_12448)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0907 25.4382C30.0907 25.7515 30.0778 26.0723 30.0526 26.3989C30.0443 26.5106 30.0342 26.6232 30.0224 26.7365C29.3985 32.8775 24.5693 40.8641 18.7046 40.8641C12.8398 40.8641 8.03423 32.9154 7.39112 26.7809C7.3798 26.6724 7.3699 26.5648 7.36121 26.4575C7.33271 26.1106 7.31836 25.7701 7.31836 25.4382C7.31836 21.038 9.85058 19.2721 13.5473 18.6132C13.6927 18.587 13.8398 18.5629 13.9886 18.5402C15.4253 18.3222 17.0224 18.2549 18.7044 18.2549C20.3863 18.2549 22.1299 18.3285 23.6172 18.5714C23.7666 18.5957 23.9145 18.6217 24.0602 18.6499C27.6487 19.3366 30.0905 21.117 30.0905 25.4382H30.0907Z",
    fill: "url(#paint2_linear_7398_12448)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7229 26.2963C27.7229 26.5444 27.7126 26.7985 27.6926 27.0572C27.6859 27.1458 27.6781 27.2348 27.6688 27.3245C27.1746 32.1884 23.3495 38.5145 18.7042 38.5145C14.059 38.5145 10.2525 32.2187 9.74315 27.3595C9.73426 27.2736 9.72637 27.1884 9.7195 27.1035C9.69686 26.8287 9.68555 26.559 9.68555 26.2961C9.68555 22.8108 11.6913 21.412 14.6194 20.8901C14.7346 20.8694 14.851 20.8502 14.9689 20.8323C16.1069 20.6596 17.3719 20.6064 18.7042 20.6064C20.0365 20.6064 21.4175 20.6648 22.5956 20.8571C22.7141 20.8763 22.8311 20.897 22.9465 20.9191C25.7888 21.4631 27.7229 22.8733 27.7229 26.2959V26.2963Z",
    fill: "url(#paint3_linear_7398_12448)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7046 38.5781C17.5873 38.5781 16.4711 38.2182 15.3868 37.5082C14.3993 36.8616 13.4706 35.9496 12.6268 34.7971C11.846 33.731 11.1621 32.4787 10.6485 31.1762C10.1423 29.8915 9.80777 28.5742 9.68105 27.3668C9.67176 27.278 9.66387 27.1912 9.6572 27.1091C9.63457 26.8331 9.62305 26.5598 9.62305 26.2966C9.62305 25.4432 9.74512 24.6816 9.98624 24.033C10.2152 23.4164 10.56 22.8795 11.0109 22.4373C11.8222 21.6417 12.9991 21.1155 14.6089 20.8286C14.7218 20.8083 14.8401 20.7887 14.9599 20.7706C15.9788 20.6159 17.1686 20.5439 18.7046 20.5439C20.2406 20.5439 21.5551 20.6238 22.6061 20.7954C22.7247 20.8146 22.8434 20.8355 22.9588 20.8578C24.5181 21.1563 25.6586 21.6883 26.4456 22.4844C26.8813 22.9249 27.2144 23.4578 27.4357 24.0675C27.6681 24.7082 27.7862 25.4582 27.7862 26.2966C27.7862 26.544 27.7758 26.8017 27.7556 27.0624C27.749 27.1513 27.7409 27.2417 27.7316 27.3313C27.6089 28.5397 27.2768 29.8595 26.7716 31.1482C26.2594 32.4544 25.5757 33.7107 24.7941 34.7811C23.0063 37.2296 20.8437 38.5779 18.7044 38.5779L18.7046 38.5781ZM18.7046 20.6701C17.175 20.6701 15.9911 20.7416 14.9787 20.8953C14.8599 20.9134 14.7429 20.9326 14.6309 20.9529C11.3001 21.5466 9.74876 23.2447 9.74876 26.2968C9.74876 26.5566 9.76008 26.8264 9.78251 27.0989C9.78898 27.1802 9.79706 27.2658 9.80616 27.3538C10.0649 29.8228 11.1573 32.5775 12.728 34.7227C14.4892 37.1278 16.6118 38.4522 18.7046 38.4522C20.7974 38.4522 22.9295 37.1221 24.6929 34.7069C26.2663 32.5519 27.3557 29.79 27.6067 27.3187C27.6158 27.2301 27.6239 27.1407 27.6303 27.0531C27.6503 26.7954 27.6604 26.5409 27.6604 26.2968C27.6604 23.2877 26.159 21.5989 22.9351 20.9819C22.8209 20.96 22.7033 20.9391 22.5859 20.9201C21.5418 20.7495 20.3083 20.6703 18.7046 20.6703V20.6701Z",
    fill: "#939598"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8511 0.15332C25.0044 0.185965 24.1663 0.485439 23.4727 1.05215L29.124 6.7217C29.6889 6.02583 29.9874 5.18499 30.02 4.33563C29.4805 3.59779 28.83 2.83582 28.088 2.09149C27.3461 1.34717 26.5863 0.694484 25.8511 0.15332Z",
    fill: "url(#paint4_linear_7398_12448)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5567 17.9726C29.724 16.154 30.4017 13.989 30.4017 11.6649C30.4017 5.22267 25.1958 0 18.7742 0C12.3526 0 7.14648 5.22267 7.14648 11.6649C7.14648 14.0048 7.83325 16.1836 9.01559 18.0099C12.9818 20.5115 24.6671 20.4991 28.5567 17.9726Z",
    fill: "url(#paint5_linear_7398_12448)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0637 18.694C26.9183 18.9414 26.7461 19.1809 26.5489 19.4104C22.321 20.747 15.0374 20.7658 10.8653 19.4051C10.6706 19.1744 10.4845 18.9029 10.3418 18.6543C14.5675 20.2699 22.7723 20.2831 27.0639 18.694H27.0637Z",
    fill: "#848C99"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5281 6.91406C24.1598 6.91406 23.8041 6.9682 23.4684 7.06877C22.0506 7.49416 20.5736 7.68759 19.0938 7.68759H18.6386C17.1586 7.68759 15.6818 7.49416 14.2638 7.06877C13.9281 6.968 13.5726 6.91406 13.2041 6.91406C11.1654 6.91406 9.51078 8.57304 9.50977 10.6183C9.50876 12.6659 11.1632 14.3263 13.2041 14.3263C13.5764 14.3263 13.9357 14.271 14.2745 14.1684C15.6682 13.7456 17.1214 13.5528 18.5774 13.5528H19.1548C20.611 13.5528 22.0639 13.7456 23.4577 14.1684C23.7964 14.2712 24.1558 14.3263 24.5281 14.3263C26.5689 14.3263 28.2234 12.6659 28.2224 10.6183C28.2214 8.57304 26.5667 6.91406 24.5281 6.91406Z",
    fill: "#01B6C9"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M28.222 10.6196C28.223 12.6673 26.5685 14.3275 24.5277 14.3275C24.4222 14.3275 24.3177 14.3232 24.2144 14.3143C23.9535 14.2924 23.7 14.2433 23.4573 14.1697C23.2857 14.1176 23.1129 14.0689 22.9397 14.0239C21.7056 13.7022 20.4311 13.5541 19.1544 13.5541H18.577C18.4668 13.5541 18.3565 13.5554 18.2463 13.5576C17.0971 13.5809 15.9524 13.7257 14.8402 14.0118C14.6506 14.0602 14.4618 14.1129 14.2743 14.1699C14.0083 14.2506 13.7296 14.3019 13.4422 14.3202C13.3634 14.3252 13.2839 14.3279 13.2041 14.3279C11.1632 14.3279 9.50876 12.6677 9.50977 10.62C9.50977 10.5624 9.51118 10.5051 9.51381 10.4483C9.60152 8.54032 11.1291 7.00807 13.0307 6.92007C13.0881 6.91744 13.1459 6.91602 13.2041 6.91602C13.5724 6.91602 13.9279 6.96995 14.2636 7.07072C15.6816 7.49611 17.1586 7.68934 18.6384 7.68934H19.0934C19.4228 7.68934 19.752 7.67981 20.0807 7.66034C20.4853 7.63622 20.8889 7.59668 21.2901 7.54132C22.0264 7.44015 22.7548 7.28463 23.4682 7.07072C23.8037 6.96995 24.1594 6.91602 24.5277 6.91602C24.6372 6.91602 24.7457 6.92088 24.8528 6.93021C26.1987 7.04801 27.3382 7.89068 27.8814 9.06668C28.0581 9.44949 28.1717 9.86758 28.2089 10.3076C28.2176 10.4108 28.222 10.5148 28.222 10.6202V10.6196Z",
    fill: "#01B6C9"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M14.27 7.06915C14.27 7.06915 14.2668 7.06875 14.2656 7.06836C14.2664 7.06836 14.268 7.06875 14.27 7.06915Z",
    fill: "#01B6C9"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M13.2061 7.74051C13.5743 7.74051 13.93 7.79464 14.2657 7.89521C15.6837 8.3206 17.1605 8.51403 18.6406 8.51403H19.0957C20.5756 8.51403 22.0526 8.3206 23.4704 7.89521C23.8061 7.79444 24.1618 7.74051 24.53 7.74031C26.4302 7.74031 27.9964 9.18152 28.2013 11.0333C28.2165 10.8971 28.2244 10.7586 28.2244 10.6183C28.2233 8.57304 26.5687 6.91406 24.53 6.91406C24.1618 6.91406 23.8061 6.9682 23.4704 7.06877C22.0526 7.49416 20.5756 7.68759 19.0957 7.68759H18.6406C17.1605 7.68759 15.6837 7.49416 14.2657 7.06877C13.93 6.968 13.5745 6.91406 13.2061 6.91406C11.1674 6.91406 9.51273 8.57304 9.51172 10.6183C9.51172 10.7586 9.5196 10.8971 9.53476 11.0333C9.7397 9.18152 11.3058 7.7401 13.2061 7.74031V7.74051Z",
    fill: "url(#paint6_linear_7398_12448)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5,
    d: "M28.2376 10.4344C28.236 10.4646 28.2342 10.4911 28.2327 10.5143C28.2309 10.5374 28.2289 10.5564 28.2275 10.572C28.2249 10.6031 28.2234 10.6191 28.2234 10.6191C28.2226 9.63164 27.8368 8.73383 27.2079 8.06979C27.2056 8.06715 27.203 8.06452 27.2004 8.06188C27.0043 7.85304 26.7729 7.65657 26.5094 7.48807C26.2102 7.29626 25.8685 7.14257 25.501 7.04444C25.4875 7.04079 25.4738 7.03734 25.46 7.03369C25.1625 6.95624 24.8507 6.91487 24.5291 6.91487C24.2429 6.91487 23.964 6.94752 23.6964 7.00956C23.6447 7.02011 23.2455 7.13304 23.1843 7.15129C23.1734 7.15433 23.162 7.15758 23.1511 7.16062C21.8312 7.52254 20.4645 7.6882 19.0948 7.6882H18.6399C17.1608 7.6882 15.6848 7.49517 14.2678 7.07039C14.2668 7.07019 14.2662 7.06999 14.2656 7.06958C14.266 7.06958 14.2668 7.06978 14.2678 7.06998C14.2814 7.07262 14.3422 7.0856 14.4453 7.10709C14.4748 7.11338 14.5075 7.12047 14.5435 7.12818C14.5797 7.13487 14.6193 7.14217 14.6622 7.15007C14.7048 7.15798 14.7507 7.1667 14.7996 7.17542C14.8487 7.18353 14.9006 7.19225 14.956 7.20137C15.1759 7.23828 15.4449 7.27193 15.7538 7.30113C16.0624 7.33012 16.4114 7.35202 16.7924 7.36257C16.9832 7.36804 17.1816 7.3721 17.3876 7.37189C17.5931 7.37331 17.8064 7.37169 18.0252 7.36845C18.1346 7.36682 18.2455 7.365 18.3579 7.36338C18.4705 7.36094 18.5847 7.35851 18.7001 7.35608C18.8155 7.35385 18.9323 7.35162 19.0501 7.34939C19.1676 7.34655 19.284 7.34371 19.4024 7.33905C19.5204 7.33296 19.6397 7.3285 19.7593 7.31978C19.8194 7.31573 19.8796 7.31289 19.9398 7.30762C19.9999 7.30255 20.0603 7.29748 20.1211 7.29221C20.3634 7.26909 20.6082 7.24294 20.854 7.20786C21.3455 7.13933 21.8417 7.04505 22.3336 6.92866C22.5794 6.87148 22.8247 6.80701 23.0656 6.7403C23.1271 6.72306 23.1883 6.70542 23.2494 6.68799L23.3397 6.66264C23.3732 6.65332 23.4064 6.64379 23.4397 6.63568C23.5727 6.60242 23.7045 6.57931 23.8355 6.56187C23.9664 6.54403 24.0968 6.53288 24.2263 6.52659C24.2916 6.52355 24.3553 6.52132 24.4212 6.52091L24.4703 6.52051H24.5168C24.5505 6.52071 24.5823 6.52213 24.615 6.52294C24.7452 6.527 24.8739 6.53754 25.0012 6.55437C25.1282 6.5716 25.2535 6.59533 25.3763 6.62473C25.8677 6.74131 26.3153 6.9538 26.6888 7.22124C27.0635 7.48828 27.3647 7.80823 27.59 8.13569C27.8162 8.46334 27.9688 8.79709 28.0662 9.10143C28.165 9.40638 28.2075 9.68213 28.2285 9.90821C28.2493 10.1349 28.2433 10.3131 28.2378 10.4338L28.2376 10.4344Z",
    fill: "url(#paint7_linear_7398_12448)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M13.2061 13.4971C13.5743 13.4971 13.93 13.443 14.2657 13.3424C15.6837 12.917 17.1605 12.7236 18.6406 12.7236H19.0957C20.5756 12.7236 22.0526 12.917 23.4704 13.3424C23.8061 13.4432 24.1618 13.4971 24.53 13.4971C26.4302 13.4971 27.9964 12.0559 28.2013 10.2041C28.2165 10.3404 28.2244 10.4788 28.2244 10.6191C28.2233 12.6644 26.5687 14.3234 24.53 14.3234C24.1618 14.3234 23.8061 14.2692 23.4704 14.1686C22.0526 13.7433 20.5756 13.5498 19.0957 13.5498H18.6406C17.1605 13.5498 15.6837 13.7433 14.2657 14.1686C13.93 14.2694 13.5745 14.3234 13.2061 14.3234C11.1674 14.3234 9.51273 12.6644 9.51172 10.6191C9.51172 10.4788 9.5196 10.3404 9.53476 10.2041C9.7397 12.0559 11.3058 13.4973 13.2061 13.4971Z",
    fill: "url(#paint8_linear_7398_12448)"
  }), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8684 24.5156C17.4795 24.5156 16.3535 25.6452 16.3535 27.0386C16.3535 28.4319 17.4795 29.5615 18.8684 29.5615C20.2572 29.5615 21.3832 28.4319 21.3832 27.0386C21.3832 25.6452 20.2572 24.5156 18.8684 24.5156ZM18.8684 29.0009C17.7881 29.0009 16.9123 28.1223 16.9123 27.0386C16.9123 25.9548 17.7881 25.0763 18.8684 25.0763C19.9486 25.0763 20.8244 25.9548 20.8244 27.0386C20.8244 28.1223 19.9486 29.0009 18.8684 29.0009Z",
    fill: "#01B6C9"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.7,
    d: "M18.8666 29.0001C17.7863 29.0001 16.9104 28.1213 16.9104 27.0376C16.9104 25.9538 17.7863 25.0753 18.8666 25.0753V24.5146C17.4775 24.5146 16.3516 25.6442 16.3516 27.0376C16.3516 28.4309 17.4775 29.5607 18.8666 29.5607V29.0001Z",
    fill: "url(#paint9_linear_7398_12448)"
  }), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7339 8.91895C23.8022 8.91895 23.0469 9.67666 23.0469 10.6114C23.0469 11.5461 23.8022 12.3038 24.7339 12.3038C25.6656 12.3038 26.4209 11.5461 26.4209 10.6114C26.4209 9.67666 25.6656 8.91895 24.7339 8.91895ZM24.7339 12.1296C23.898 12.1296 23.2203 11.4498 23.2203 10.6112C23.2203 9.77256 23.898 9.09271 24.7339 9.09271C25.5698 9.09271 26.2475 9.77256 26.2475 10.6112C26.2475 11.4498 25.5698 12.1296 24.7339 12.1296Z",
    fill: "#A8F4FF"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0383 8.08887C11.6494 8.08887 10.5234 9.21844 10.5234 10.6118C10.5234 12.0052 11.6494 13.1347 13.0383 13.1347C14.4272 13.1347 15.5531 12.0052 15.5531 10.6118C15.5531 9.21844 14.4272 8.08887 13.0383 8.08887ZM13.0383 12.5741C11.958 12.5741 11.0823 11.6955 11.0823 10.6118C11.0823 9.52805 11.958 8.6495 13.0383 8.6495C14.1185 8.6495 14.9943 9.52805 14.9943 10.6118C14.9943 11.6955 14.1185 12.5741 13.0383 12.5741Z",
    fill: "#A8F4FF"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0386 8.91895C12.1068 8.91895 11.3516 9.67666 11.3516 10.6114C11.3516 11.5461 12.1068 12.3038 13.0386 12.3038C13.9703 12.3038 14.7256 11.5461 14.7256 10.6114C14.7256 9.67666 13.9703 8.91895 13.0386 8.91895ZM13.0386 12.1296C12.2026 12.1296 11.525 11.4498 11.525 10.6112C11.525 9.77256 12.2026 9.09271 13.0386 9.09271C13.8745 9.09271 14.5522 9.77256 14.5522 10.6112C14.5522 11.4498 13.8745 12.1296 13.0386 12.1296Z",
    fill: "#A8F4FF"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7355 8.08887C23.3467 8.08887 22.2207 9.21844 22.2207 10.6118C22.2207 12.0052 23.3467 13.1347 24.7355 13.1347C26.1244 13.1347 27.2504 12.0052 27.2504 10.6118C27.2504 9.21844 26.1244 8.08887 24.7355 8.08887ZM24.7355 12.5741C23.6553 12.5741 22.7795 11.6955 22.7795 10.6118C22.7795 9.52805 23.6553 8.6495 24.7355 8.6495C25.8158 8.6495 26.6915 9.52805 26.6915 10.6118C26.6915 11.6955 25.8158 12.5741 24.7355 12.5741Z",
    fill: "#A8F4FF"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3082 28.1046C19.8951 27.8607 20.1738 27.1857 19.9307 26.597C19.6876 26.0082 19.0148 25.7286 18.4279 25.9725C17.841 26.2164 17.5623 26.8914 17.8054 27.4801C18.0485 28.0689 18.7213 28.3485 19.3082 28.1046Z",
    fill: "#01B6C9"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.15
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1432 8.67188C15.9433 8.67188 15.7812 8.83449 15.7812 9.03502C15.7812 9.23554 15.9433 9.39816 16.1432 9.39816C16.3431 9.39816 16.5052 9.23554 16.5052 9.03502C16.5052 8.83449 16.3431 8.67188 16.1432 8.67188Z",
    fill: "#01B6C9"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.15
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1455 9.39102C17.3401 9.34495 17.4606 9.14937 17.4147 8.95417C17.3688 8.75898 17.1738 8.63809 16.9792 8.68416C16.7847 8.73023 16.6642 8.92581 16.7101 9.12101C16.756 9.3162 16.951 9.43709 17.1455 9.39102Z",
    fill: "#01B6C9"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.15
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0509 9.39158C18.2472 9.35366 18.3757 9.16326 18.3379 8.96632C18.3001 8.76938 18.1103 8.64048 17.914 8.6784C17.7177 8.71633 17.5892 8.90672 17.627 9.10366C17.6648 9.3006 17.8546 9.42951 18.0509 9.39158Z",
    fill: "#01B6C9"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.15
  }, _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9049 8.67188C18.7051 8.67188 18.543 8.83449 18.543 9.03502C18.543 9.23554 18.7051 9.39816 18.9049 9.39816C19.1048 9.39816 19.2669 9.23554 19.2669 9.03502C19.2669 8.83449 19.1048 8.67188 18.9049 8.67188Z",
    fill: "#01B6C9"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.15
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9073 9.39102C20.1018 9.34495 20.2223 9.14937 20.1764 8.95417C20.1305 8.75898 19.9355 8.63809 19.741 8.68416C19.5464 8.73023 19.4259 8.92581 19.4718 9.12101C19.5177 9.3162 19.7127 9.43709 19.9073 9.39102Z",
    fill: "#01B6C9"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.15
  }, _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8272 9.39102C21.0218 9.34495 21.1423 9.14937 21.0963 8.95417C21.0504 8.75898 20.8555 8.63809 20.6609 8.68416C20.4663 8.73023 20.3458 8.92581 20.3917 9.12101C20.4377 9.3162 20.6326 9.43709 20.8272 9.39102Z",
    fill: "#01B6C9"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.15
  }, _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7326 9.39158C21.9289 9.35366 22.0574 9.16326 22.0196 8.96632C21.9818 8.76938 21.792 8.64048 21.5957 8.6784C21.3994 8.71633 21.2709 8.90672 21.3087 9.10366C21.3465 9.3006 21.5363 9.42951 21.7326 9.39158Z",
    fill: "#01B6C9"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.15
  }, _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1432 10.2275C15.9433 10.2275 15.7812 10.3902 15.7812 10.5907C15.7812 10.7912 15.9433 10.9538 16.1432 10.9538C16.3431 10.9538 16.5052 10.7912 16.5052 10.5907C16.5052 10.3902 16.3431 10.2275 16.1432 10.2275Z",
    fill: "#01B6C9"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.15
  }, _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4229 10.6365C17.4474 10.4375 17.3063 10.2563 17.1079 10.2317C16.9095 10.2072 16.7288 10.3487 16.7044 10.5478C16.68 10.7468 16.821 10.9281 17.0194 10.9526C17.2178 10.9771 17.3985 10.8356 17.4229 10.6365Z",
    fill: "#01B6C9"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.15
  }, _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2925 10.7839C18.3976 10.6133 18.3449 10.3895 18.1749 10.2841C18.0048 10.1786 17.7818 10.2314 17.6766 10.402C17.5715 10.5726 17.6242 10.7964 17.7942 10.9019C17.9643 11.0073 18.1874 10.9545 18.2925 10.7839Z",
    fill: "#01B6C9"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.15
  }, _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9049 10.2275C18.7051 10.2275 18.543 10.3902 18.543 10.5907C18.543 10.7912 18.7051 10.9538 18.9049 10.9538C19.1048 10.9538 19.2669 10.7912 19.2669 10.5907C19.2669 10.3902 19.1048 10.2275 18.9049 10.2275Z",
    fill: "#01B6C9"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.15
  }, _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1846 10.6356C20.2091 10.4365 20.068 10.2553 19.8696 10.2308C19.6712 10.2063 19.4905 10.3478 19.4661 10.5468C19.4417 10.7459 19.5827 10.9271 19.7811 10.9516C19.9796 10.9761 20.1602 10.8346 20.1846 10.6356Z",
    fill: "#01B6C9"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.15
  }, _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1046 10.6365C21.129 10.4375 20.988 10.2563 20.7895 10.2317C20.5911 10.2072 20.4105 10.3487 20.386 10.5478C20.3616 10.7468 20.5026 10.9281 20.7011 10.9526C20.8995 10.9771 21.0801 10.8356 21.1046 10.6365Z",
    fill: "#01B6C9"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.15
  }, _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9741 10.7839C22.0792 10.6133 22.0266 10.3895 21.8565 10.2841C21.6865 10.1786 21.4634 10.2314 21.3583 10.402C21.2532 10.5726 21.3058 10.7964 21.4759 10.9019C21.6459 11.0073 21.869 10.9545 21.9741 10.7839Z",
    fill: "#01B6C9"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.15
  }, _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1432 11.8291C15.9433 11.8291 15.7812 11.9917 15.7812 12.1922C15.7812 12.3928 15.9433 12.5554 16.1432 12.5554C16.3431 12.5554 16.5052 12.3928 16.5052 12.1922C16.5052 11.9917 16.3431 11.8291 16.1432 11.8291Z",
    fill: "#01B6C9"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.15
  }, _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4229 12.2381C17.4474 12.0391 17.3063 11.8578 17.1079 11.8333C16.9095 11.8088 16.7288 11.9503 16.7044 12.1493C16.68 12.3484 16.821 12.5296 17.0194 12.5541C17.2178 12.5787 17.3985 12.4372 17.4229 12.2381Z",
    fill: "#01B6C9"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.15
  }, _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2925 12.3845C18.3976 12.2139 18.3449 11.9901 18.1749 11.8847C18.0048 11.7792 17.7818 11.832 17.6766 12.0026C17.5715 12.1732 17.6242 12.397 17.7942 12.5025C17.9643 12.6079 18.1874 12.5551 18.2925 12.3845Z",
    fill: "#01B6C9"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.15
  }, _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9049 11.8291C18.7051 11.8291 18.543 11.9917 18.543 12.1922C18.543 12.3928 18.7051 12.5554 18.9049 12.5554C19.1048 12.5554 19.2669 12.3928 19.2669 12.1922C19.2669 11.9917 19.1048 11.8291 18.9049 11.8291Z",
    fill: "#01B6C9"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.15
  }, _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1846 12.2371C20.2091 12.0381 20.068 11.8568 19.8696 11.8323C19.6712 11.8078 19.4905 11.9493 19.4661 12.1484C19.4417 12.3474 19.5827 12.5287 19.7811 12.5532C19.9796 12.5777 20.1602 12.4362 20.1846 12.2371Z",
    fill: "#01B6C9"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.15
  }, _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1046 12.2371C21.129 12.0381 20.988 11.8568 20.7895 11.8323C20.5911 11.8078 20.4105 11.9493 20.386 12.1484C20.3616 12.3474 20.5026 12.5287 20.7011 12.5532C20.8995 12.5777 21.0801 12.4362 21.1046 12.2371Z",
    fill: "#01B6C9"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.15
  }, _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9741 12.3855C22.0792 12.2149 22.0266 11.9911 21.8565 11.8856C21.6865 11.7802 21.4634 11.833 21.3583 12.0036C21.2532 12.1742 21.3058 12.398 21.4759 12.5034C21.6459 12.6089 21.869 12.5561 21.9741 12.3855Z",
    fill: "#01B6C9"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.15
  }, _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6955 10.1797C16.8918 10.1417 17.0203 9.95135 16.9825 9.75441C16.9447 9.55747 16.7549 9.42856 16.5586 9.46649C16.3623 9.50441 16.2338 9.69481 16.2716 9.89175C16.3094 10.0887 16.4992 10.2176 16.6955 10.1797Z",
    fill: "#01B6C9"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.15
  }, _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5495 10.1862C17.7494 10.1862 17.9115 10.0237 17.9115 9.8231C17.9115 9.62254 17.7494 9.45996 17.5495 9.45996C17.3496 9.45996 17.1875 9.62254 17.1875 9.8231C17.1875 10.0237 17.3496 10.1862 17.5495 10.1862Z",
    fill: "#01B6C9"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.15
  }, _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4986 10.1841C18.6978 10.1676 18.8459 9.99212 18.8295 9.79225C18.813 9.59238 18.6381 9.44375 18.4389 9.46029C18.2396 9.47683 18.0915 9.65226 18.108 9.85214C18.1245 10.052 18.2993 10.2006 18.4986 10.1841Z",
    fill: "#01B6C9"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.15
  }, _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3893 9.45996C19.1894 9.45996 19.0273 9.62257 19.0273 9.8231C19.0273 10.0236 19.1894 10.1862 19.3893 10.1862C19.5892 10.1862 19.7513 10.0236 19.7513 9.8231C19.7513 9.62257 19.5892 9.45996 19.3893 9.45996Z",
    fill: "#01B6C9"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.15
  }, _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3916 10.1791C20.5862 10.133 20.7067 9.93745 20.6608 9.74226C20.6149 9.54707 20.4199 9.42618 20.2253 9.47225C20.0308 9.51832 19.9103 9.7139 19.9562 9.90909C20.0021 10.1043 20.1971 10.2252 20.3916 10.1791Z",
    fill: "#01B6C9"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.15
  }, _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3116 10.1762C21.5061 10.1301 21.6266 9.93452 21.5807 9.73933C21.5348 9.54414 21.3398 9.42325 21.1453 9.46932C20.9507 9.51539 20.8302 9.71097 20.8761 9.90617C20.922 10.1014 21.117 10.2222 21.3116 10.1762Z",
    fill: "#01B6C9"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.15
  }, _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M16.937 11.572C17.0421 11.4014 16.9895 11.1776 16.8194 11.0722C16.6493 10.9667 16.4263 11.0195 16.3212 11.1901C16.2161 11.3607 16.2687 11.5845 16.4388 11.69C16.6088 11.7954 16.8319 11.7426 16.937 11.572Z",
    fill: "#01B6C9"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.15
  }, _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5495 11.7429C17.7494 11.7429 17.9115 11.5803 17.9115 11.3797C17.9115 11.1792 17.7494 11.0166 17.5495 11.0166C17.3496 11.0166 17.1875 11.1792 17.1875 11.3797C17.1875 11.5803 17.3496 11.7429 17.5495 11.7429Z",
    fill: "#01B6C9"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.15
  }, _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7249 11.6367C18.8663 11.4948 18.8663 11.2649 18.7249 11.1231C18.5835 10.9813 18.3543 10.9813 18.213 11.1231C18.0716 11.2649 18.0716 11.4948 18.213 11.6367C18.3543 11.7785 18.5835 11.7785 18.7249 11.6367Z",
    fill: "#01B6C9"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.15
  }, _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3893 11.0166C19.1894 11.0166 19.0273 11.1792 19.0273 11.3797C19.0273 11.5803 19.1894 11.7429 19.3893 11.7429C19.5892 11.7429 19.7513 11.5803 19.7513 11.3797C19.7513 11.1792 19.5892 11.0166 19.3893 11.0166Z",
    fill: "#01B6C9"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.15
  }, _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M20.669 11.4246C20.6934 11.2256 20.5524 11.0443 20.354 11.0198C20.1556 10.9953 19.9749 11.1368 19.9505 11.3359C19.9261 11.5349 20.0671 11.7162 20.2655 11.7407C20.4639 11.7652 20.6446 11.6237 20.669 11.4246Z",
    fill: "#01B6C9"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.15
  }, _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5889 11.4246C21.6134 11.2256 21.4723 11.0443 21.2739 11.0198C21.0755 10.9953 20.8948 11.1368 20.8704 11.3359C20.846 11.5349 20.987 11.7162 21.1854 11.7407C21.3838 11.7652 21.5645 11.6237 21.5889 11.4246Z",
    fill: "#01B6C9"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5,
    d: "M30.4006 11.6659C30.4006 12.2991 30.35 12.9209 30.2532 13.5272C30.253 13.5274 30.253 13.528 30.253 13.5282C30.018 4.43122 23.6639 0.514731 18.9238 0.00195312C25.2759 0.0830567 30.4006 5.27429 30.4006 11.6661V11.6659Z",
    fill: "url(#paint10_linear_7398_12448)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.7,
    d: "M21.382 27.0376C21.382 25.6442 20.2561 24.5146 18.8672 24.5146V25.0753C19.9473 25.0753 20.8232 25.954 20.8232 27.0376C20.8232 28.1211 19.9473 29.0001 18.8672 29.0001V29.5607C20.2561 29.5607 21.382 28.4311 21.382 27.0376Z",
    fill: "url(#paint11_linear_7398_12448)"
  }), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7937 19.8482C36.6454 19.4753 37.7057 18.3831 37.9613 17.6464C37.2515 17.0359 33.965 14.9945 33.7498 14.8027C33.386 15.1107 32.9525 15.5923 32.8672 16.3145C33.462 16.8863 35.5368 19.6572 35.7935 19.8484L35.7937 19.8482Z",
    fill: "url(#paint12_linear_7398_12448)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M38.5647 12.3256C39.6622 13.0924 40.4819 13.8937 39.6741 15.69C39.6573 15.7275 39.6396 15.7656 39.6212 15.8043C39.449 16.1652 39.2131 16.5653 38.9033 17.0118C38.6921 17.3161 38.455 17.6292 38.1993 17.9444C37.5611 18.2208 36.3824 17.8546 35.3312 17.2356C35.2502 17.1815 35.1675 17.1283 35.0832 17.0762C35.0363 17.0472 34.9892 17.0191 34.9423 16.9913C34.3451 16.592 33.8465 16.1431 33.5217 15.7086C33.3853 15.5261 33.2493 15.3049 33.1777 15.0758C33.4643 14.5555 33.7643 14.0663 34.0658 13.6322C34.3132 13.2757 34.5494 12.9738 34.776 12.7206C34.8043 12.6887 34.8326 12.6577 34.8609 12.6275C36.3492 11.0257 37.4222 11.5279 38.5643 12.3256H38.5647Z",
    fill: "url(#paint13_linear_7398_12448)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5,
    d: "M34.0699 13.6323C33.7684 14.0664 33.4684 14.5556 33.1816 15.0759C33.2176 15.1911 33.27 15.3042 33.3304 15.4117C33.6135 14.8997 33.9917 14.2262 34.2516 13.8519C36.1733 11.0836 37.4144 11.6122 38.7501 12.5453C39.0814 12.7768 39.3872 13.0114 39.6307 13.2754C39.3678 12.918 38.9884 12.6193 38.5682 12.3257C37.2325 11.3926 35.9914 10.864 34.0697 13.6323H34.0699Z",
    fill: "url(#paint14_linear_7398_12448)"
  }), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M35.9158 20.1107C35.9293 19.8755 35.8834 19.6259 35.8236 19.4106C35.6781 18.8873 35.3762 18.2873 34.9643 17.6977C34.9305 17.6545 34.897 17.6111 34.8636 17.5671C34.8044 17.4885 34.7472 17.4096 34.6916 17.3303C34.1213 16.6048 33.4305 15.9872 32.8268 15.7393C30.8032 17.675 29.1421 20.015 29.7943 20.9907C30.4578 21.9828 33.3288 21.29 35.9156 20.1107H35.9158Z",
    fill: "url(#paint15_linear_7398_12448)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5,
    d: "M33.003 15.8208C32.9436 15.7904 32.8847 15.763 32.8267 15.7393C30.8034 17.675 29.1421 20.015 29.7943 20.9907C29.4071 19.9143 31.0817 17.7119 33.003 15.821V15.8208Z",
    fill: "url(#paint16_linear_7398_12448)"
  }), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2402 0.872752L25.7825 0.333008C27.1975 1.44068 28.3794 2.57998 29.4134 3.89041L29.0943 4.03944C27.7511 2.77118 26.1384 1.71177 24.2402 0.872955V0.872752Z",
    fill: "url(#paint17_linear_7398_12448)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.1,
    d: "M20.0809 7.66014L13.4422 14.3202C13.3634 14.3252 13.2839 14.3279 13.2041 14.3279C11.1632 14.3279 9.50876 12.6677 9.50977 10.62C9.50977 10.5624 9.51118 10.5051 9.51381 10.4483L13.0307 6.92007C13.0881 6.91744 13.1459 6.91602 13.2041 6.91602C13.5724 6.91602 13.9279 6.96995 14.2636 7.07072C15.6816 7.49611 17.1586 7.68934 18.6384 7.68934H19.0934C19.4228 7.68934 19.752 7.67981 20.0807 7.66034L20.0809 7.66014Z",
    fill: "url(#paint18_linear_7398_12448)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.1,
    d: "M24.8545 6.93001L18.2479 13.5578C17.0987 13.5811 15.954 13.7259 14.8418 14.012L21.2917 7.54132C22.028 7.44015 22.7564 7.28463 23.4698 7.07072C23.8053 6.96995 24.161 6.91602 24.5293 6.91602C24.6388 6.91602 24.7473 6.92088 24.8545 6.93021V6.93001Z",
    fill: "url(#paint19_linear_7398_12448)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.1,
    d: "M28.2106 10.3081L24.2161 14.3154C23.9552 14.2935 23.7017 14.2444 23.459 14.1708C23.2874 14.1187 23.1146 14.0701 22.9414 14.025L27.8832 9.06738C28.0598 9.45019 28.1734 9.86828 28.2106 10.3083V10.3081Z",
    fill: "url(#paint20_linear_7398_12448)"
  }), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M6.53765 27.0435C6.4182 27.8679 6.34645 28.3868 6.1211 29.0585C5.26032 28.6928 1.46836 27.2114 1.20117 27.1035C1.20117 26.7736 1.70786 25.5763 1.91259 25.3643C2.68768 25.6441 6.25268 26.8979 6.53745 27.0435H6.53765Z",
    fill: "url(#paint21_linear_7398_12448)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M2.1833 32.9529C3.47255 33.3096 4.61062 33.4302 5.47161 31.6589C5.48959 31.6218 5.50758 31.5839 5.52557 31.545C5.69231 31.1816 5.84834 30.7439 5.99244 30.2193C6.09087 29.8619 6.17939 29.4788 6.25761 29.08C6.06156 28.4111 5.02757 27.7353 3.88121 27.3201C3.78784 27.2921 3.69447 27.2623 3.60048 27.2307C3.54834 27.213 3.4966 27.1948 3.44527 27.1763C2.75749 26.9707 2.09478 26.8728 1.55413 26.9C1.32696 26.9113 1.07069 26.9478 0.84918 27.039C0.63353 27.5928 0.450015 28.1368 0.309954 28.6469C0.194752 29.0656 0.114313 29.4409 0.0649985 29.7775C0.0587332 29.8197 0.0530741 29.8615 0.0478193 29.9024C-0.22907 32.0744 0.841702 32.5815 2.1831 32.9529H2.1833Z",
    fill: "url(#paint22_linear_7398_12448)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5,
    d: "M0.306054 28.65C0.446115 28.1401 0.62963 27.5957 0.84528 27.0421C0.956642 26.9963 1.0769 26.9643 1.19776 26.9424C0.98615 27.488 0.711484 28.2104 0.590623 28.65C-0.303708 31.9019 0.894797 32.5217 2.46397 32.9562C2.85303 33.0639 3.22834 33.1498 3.58648 33.1691C3.14427 33.1947 2.67295 33.0929 2.1794 32.9562C0.610228 32.5217 -0.588074 31.9019 0.306054 28.65Z",
    fill: "url(#paint23_linear_7398_12448)"
  }), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M6.73337 27.0437C6.51529 27.1311 6.26467 27.1664 6.04215 27.1773C5.50131 27.2043 4.83839 27.1066 4.15082 26.901C4.09948 26.8825 4.04774 26.8643 3.9956 26.8464C3.90263 26.815 3.80986 26.7854 3.7173 26.7576C2.85106 26.4442 2.04849 25.9819 1.62305 25.4857C2.81387 22.948 4.50148 20.627 5.63046 20.9395C6.77843 21.2574 7.03107 24.209 6.73357 27.0437H6.73337Z",
    fill: "url(#paint24_linear_7398_12448)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5,
    d: "M1.75583 25.6277C1.70834 25.5806 1.66387 25.5334 1.62305 25.4857C2.81387 22.948 4.50148 20.627 5.63046 20.9395C4.48996 20.9111 2.93675 23.2014 1.75603 25.6279L1.75583 25.6277Z",
    fill: "url(#paint25_linear_7398_12448)"
  }), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7398_12448",
    x1: 11.1895,
    y1: 3.88781,
    x2: 9.39407,
    y2: 2.09813,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0071BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#097EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#1C9CC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#2AB1CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#33BED3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#36C3D5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_7398_12448",
    x1: 10.6626,
    y1: 4.03924,
    x2: 10.6626,
    y2: 0.333008,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#111B33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#131D36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#1C2641"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#2A3653"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#3E4B6C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#57668D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#59688F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_7398_12448",
    x1: 18.7046,
    y1: 40.8643,
    x2: 18.7046,
    y2: 18.2551,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9C9DA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#B3B4B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#C6C8C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#D3D5D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#DBDDDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DEE0DF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_7398_12448",
    x1: 18.7042,
    y1: 38.5147,
    x2: 18.7042,
    y2: 20.6066,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9C9DA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#A6A7AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#BEC0C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#D0D2D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#DADCDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DEE0DF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_7398_12448",
    x1: 26.2987,
    y1: 3.88767,
    x2: 28.0941,
    y2: 2.09798,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0071BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#097EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#1C9CC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#2AB1CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#33BED3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#36C3D5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_7398_12448",
    x1: 18.774,
    y1: 19.8769,
    x2: 18.774,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9C9DA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#A8A9AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#C0C1C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#D0D2D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#DADCDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DEE0DF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_7398_12448",
    x1: 18.8681,
    y1: 11.0335,
    x2: 18.8681,
    y2: 6.91427,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E5180"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#3E5180"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E5180"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_7398_12448",
    x1: 21.2541,
    y1: 10.6266,
    x2: 21.2541,
    y2: 6.50692,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9C9DA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#A8A9AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#C0C1C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#D0D2D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#DADCDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DEE0DF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_7398_12448",
    x1: 18.8681,
    y1: 10.2041,
    x2: 18.8681,
    y2: 14.3234,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E5180"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#3E5180"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E5180"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_7398_12448",
    x1: 16.3514,
    y1: 27.0378,
    x2: 18.8664,
    y2: 27.0378,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E5180"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#3E5180"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E5180"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_7398_12448",
    x1: 24.6623,
    y1: 13.528,
    x2: 24.6623,
    y2: 0.00175076,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9C9DA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#A8A9AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#C0C1C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#D0D2D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#DADCDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DEE0DF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_7398_12448",
    x1: 18.8672,
    y1: 27.0378,
    x2: 21.382,
    y2: 27.0378,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E5180"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#3E5180"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E5180"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_7398_12448",
    x1: 37.2044,
    y1: 16.1107,
    x2: 33.6448,
    y2: 17.8752,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0071BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#097EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#1C9CC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#2AB1CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#33BED3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#36C3D5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_7398_12448",
    x1: 38.9231,
    y1: 17.3323,
    x2: 34.9107,
    y2: 12.5201,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9C9DA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#B2B4B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#C6C7C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#D3D5D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#DBDDDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DEE0DF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_7398_12448",
    x1: 37.2389,
    y1: 15.2609,
    x2: 34.9377,
    y2: 12.501,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9C9DA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#A8A9AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#C0C1C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#D0D2D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#DADCDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DEE0DF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_7398_12448",
    x1: 31.4678,
    y1: 16.192,
    x2: 33.1293,
    y2: 21.1619,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DEE0DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#DBDDDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#D3D5D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#C6C7C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#B2B4B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9C9DA1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_7398_12448",
    x1: 31.9958,
    y1: 20.2509,
    x2: 30.7215,
    y2: 16.4391,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9C9DA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#A8A9AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#C0C1C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#D0D2D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#DADCDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DEE0DF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_7398_12448",
    x1: 26.8268,
    y1: 4.03924,
    x2: 26.8268,
    y2: -0.916798,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#111B33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#131D36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#1C2641"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#2A3653"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#3E4B6C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#57668D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#59688F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_7398_12448",
    x1: 9.50956,
    y1: 10.6216,
    x2: 20.0809,
    y2: 10.6216,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9C9DA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#A8A9AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#C0C1C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#D0D2D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#DADCDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DEE0DF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_7398_12448",
    x1: 14.8418,
    y1: 10.4639,
    x2: 24.8545,
    y2: 10.4639,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9C9DA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#A8A9AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#C0C1C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#D0D2D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#DADCDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DEE0DF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_7398_12448",
    x1: 22.9414,
    y1: 11.6913,
    x2: 28.2106,
    y2: 11.6913,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9C9DA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#A8A9AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#C0C1C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#D0D2D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#DADCDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DEE0DF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_7398_12448",
    x1: 3.86961,
    y1: 29.0587,
    x2: 3.86961,
    y2: 25.3645,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0071BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#097EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#1C9CC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#2AB1CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#33BED3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#36C3D5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_7398_12448",
    x1: 6.25761,
    y1: 30.0326,
    x2: 0.00416418,
    y2: 30.0326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9C9DA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#B2B4B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#C6C7C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#D3D5D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#DBDDDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DEE0DF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_7398_12448",
    x1: 3.58648,
    y1: 30.0576,
    x2: -0.000140453,
    y2: 30.0576,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9C9DA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#A8A9AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#C0C1C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#D0D2D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#DADCDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DEE0DF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_7398_12448",
    x1: 1.62305,
    y1: 24.0463,
    x2: 6.84796,
    y2: 24.0463,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DEE0DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#DBDDDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#D3D5D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#C6C7C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#B2B4B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9C9DA1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_7398_12448",
    x1: 5.63046,
    y1: 23.2694,
    x2: 1.62305,
    y2: 23.2694,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9C9DA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#A8A9AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#C0C1C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#D0D2D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#DADCDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DEE0DF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar);
export default __webpack_public_path__ + "static/media/avatar.9a7aa72893a29f9995ac41e8e1e4f80f.svg";
export { ForwardRef as ReactComponent };